<template>
  <div id="kreta-account-transfer-modal">
    <generic-modal
      ref="generic-modal"
      :titleText="currentComponent.titleText"
      :description="currentComponent.description"
      :okText="currentComponent.okText"
      :okAction="currentComponent.okAction"
      :cancelText="currentComponent.cancelText"
      :cancelAction="currentComponent.cancelAction"
      :esc-action="currentComponent.escAction"
      :can-be-closed-with-esc="currentComponent.canBeClosedWithEsc"
      :width="312"
    >
      <template
        slot="modal-header"
        slot-scope="{ titleText, titleStyle, hasExit, hasSeparator }"
      >
        <modal-header
          :titleText="titleText"
          :titleStyle="titleStyle"
          :hasExit="hasExit"
          :hasSeparator="hasSeparator"
        />
      </template>
    </generic-modal>
  </div>
</template>

<script>
import ModalHeader from '@/components/shared/elements/modal/ModalHeader';
import GenericModal from '@/components/shared/elements/modal/GenericModal';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'KretaAccountTransferModal',
  props: {
    newUser: {
      type: Object,
    },
  },
  components: {
    ModalHeader,
    GenericModal,
  },
  data: () => ({
    currentState: 0,
    cancelMemberShipErrorObject: undefined,
  }),
  created() {},
  computed: {
    ...mapGetters({
      loggedInUserProfile: 'users/loggedInUserProfile',
      getLang: 'settings/getSiteLanguage',
    }),
    user() {
      return this.loggedInUserProfile.user;
    },
    isProUserAndHasSubscription() {
      if (!this.user.state || !this.user.state.payment) {
        return false;
      }
      return this.user.state.payment.subscriptionStatus === 'active';
    },
    currentComponent() {
      switch (this.currentState) {
        case 0:
          return this.saveIdModalComponent;
        case 1:
          return this.cancelSubscriptionComponent;
        case 2:
          return this.cancelMemberShipErrorComponent;
        case 3:
          return this.successTransferComponent;
        case 4:
          return this.successTransferAndUnSubscribeComponent;
        default:
          return this.saveIdModalComponent;
      }
    },
    saveIdModalComponent() {
      return {
        titleText: this.$t('app.dkt.saveUserId.modal.title'),
        description: this.$t('app.dkt.saveUserId.modal.description', {
          id: this.user.invitationCode,
          email: this.$t('app.info.email'),
        }),
        okText: this.$t('app.dkt.saveUserId.modal.OkText'),
        okAction: () => {
          this.saveIdModalOkAction();
        },
        canBeClosedWithEsc: false,
      };
    },
    cancelSubscriptionComponent() {
      return {
        titleText: this.$t('app.dkt.cancelSubscription.modal.title'),
        description: this.$t('app.dkt.cancelSubscription.modal.description'),
        okText: this.$t('app.dkt.cancelSubscription.modal.okText'),
        cancelText: this.$t('app.dkt.cancelSubscription.modal.cancelText'),
        okAction: () => {
          this.cancelSubscriptionModalOkAction();
        },
        cancelAction: () => {
          this.cancelSubscriptionModalCancelAction();
        },
        canBeClosedWithEsc: false,
      };
    },
    cancelMemberShipErrorComponent() {
      return {
        titleText: this.$t('app.dkt.cancelSubscriptionModal.title'),
        description: this.$t('app.dkt.cancelSubscriptionModal.description'),
        okText: this.$t('app.dkt.cancelSubscriptionModal.okText'),
        cancelText: this.$t('app.dkt.cancelSubscriptionModal.cancelText'),
        okAction: () => {
          this.cancelMembershipErrorModalOkAction();
        },
        cancelAction: () => {
          this.$emit('accountTransferredSuccessful');
        },
      };
    },
    successTransferComponent() {
      return {
        titleText: this.$t('app.dkt.successTransfer.title'),
        description: this.$t('app.dkt.successTransfer.description'),
        okText: this.$t('app.dkt.successTransfer.okText'),
        cancelText: this.$t('app.dkt.successTransfer.cancelText'),
        okAction: () => {
          this.$emit('accountTransferredSuccessful');
        },
        cancelAction: () => {
          this.openHowToUnsubscribe();
        },
      };
    },
    successTransferAndUnSubscribeComponent() {
      return {
        titleText: this.$t('app.dkt.cancelSubscriptionSuccess.modal.title'),
        description: this.$t('app.dkt.cancelSubscriptionSuccess.modal.description'),
        okText: this.$t('app.dkt.cancelSubscriptionSuccess.modal.okText'),
        okAction: () => {
          this.$emit('accountTransferredSuccessful');
        },
        canBeClosedWithEsc: false,
      };
    },
  },
  methods: {
    ...mapActions({
      cancelSubscriptionForDkt: 'subscriptions/cancelSubscriptionForDkt',
    }),
    openHowToUnsubscribe() {
      let website =
        this.getLang == 'hu_HU'
          ? 'https://segitseg.xeropan.com/help/hogyan-lehet-lemondani-az-elofizetest'
          : 'https://helpcenter.xeropan.com/help/how-can-i-cancel-my-subscription';
      if (
        this.cancelMemberShipErrorObject &&
        this.cancelMemberShipErrorObject.errors[0].code === 619
      ) {
        website =
          this.getLang == 'hu_HU'
            ? 'https://support.apple.com/hu-hu/HT202039'
            : 'https://support.apple.com/en-us/HT202039';
      }
      window.open(website, '_blank');
    },
    saveIdModalOkAction() {
      if (this.isProUserAndHasSubscription) {
        this.goToCancelSubscriptionModal();
      } else {
        this.$emit('accountTransferredSuccessful');
      }
    },
    cancelSubscriptionModalOkAction() {
      this.cancelMembership()
        .then(() => {
          this.goToSuccessTransferAndUnSubscribeModal();
        })
        .catch(() => {
          this.goToCancelMemberShipErrorModal();
        });
    },
    cancelSubscriptionModalCancelAction() {
      this.$emit('accountTransferredSuccessful');
    },
    cancelMembership() {
      return new Promise((resolve, reject) => {
        this.cancelSubscriptionForDkt({})
          .then((response) => {
            if (response.hasError()) {
              this.cancelMemberShipErrorObject = response;
              reject();
            } else if (!this.user.state.payment.product.hasTrialPeriod) {
              // gtag measurement point
              if (this.$gtag) {
                this.$gtag.event('Cancel Subscription', {
                  event_category: 'Settings',
                  event_label: 'PRO End',
                });
              }
              resolve();
            } else if (this.$gtag) {
              // gtag measurement point
              this.$gtag.event('Cancel Subscription', {
                event_category: 'Settings',
                event_label: 'TRIAL End',
              });
              resolve();
            }
          })
          .catch(error => console.error(error));
      });
    },
    cancelMembershipErrorModalOkAction() {
      this.openHowToUnsubscribe();
      this.goToSuccessTransferModal();
    },
    goToCancelSubscriptionModal() {
      this.$anime({
        targets: this.$refs['generic-modal'],
        duration: 300,
        height: 330,
        easing: 'easeInOutSine',
        complete: () => {},
      });
      setTimeout(() => {
        this.currentState = 1;
      }, 150);
    },
    goToCancelMemberShipErrorModal() {
      this.$anime({
        targets: this.$refs['generic-modal'],
        duration: 300,
        height: 372,
        easing: 'easeInOutSine',
        complete: () => {},
      });
      setTimeout(() => {
        this.currentState = 2;
      }, 150);
    },
    goToSuccessTransferModal() {
      this.$anime({
        targets: this.$refs['generic-modal'],
        duration: 300,
        height: 308,
        easing: 'easeInOutSine',
        complete: () => {},
      });
      setTimeout(() => {
        this.currentState = 3;
      }, 150);
    },
    goToSuccessTransferAndUnSubscribeModal() {
      this.$anime({
        targets: this.$refs['generic-modal'],
        duration: 300,
        height: 308,
        easing: 'easeInOutSine',
        complete: () => {},
      });
      setTimeout(() => {
        this.currentState = 4;
      }, 150);
    },
  },
};
</script>

<style lang="scss" scoped>
#kreta-account-transfer-modal {
}
</style>
